import React from 'react';
import './UploadProgress.css';

const UploadProgress = ({ fileData, onRemove, disabled }) => {
  const { file, name, size, preview, status, progress, error } = fileData;

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const getStatusIcon = () => {
    switch (status) {
      case 'pending':
        return '⏳';
      case 'uploading':
        return '⬆️';
      case 'success':
        return '✅';
      case 'error':
        return '❌';
      default:
        return '📄';
    }
  };

  const getStatusText = () => {
    switch (status) {
      case 'pending':
        return 'Ready to upload';
      case 'uploading':
        return `Uploading... ${progress}%`;
      case 'success':
        return 'Upload complete';
      case 'error':
        return `Error: ${error}`;
      default:
        return 'Unknown status';
    }
  };

  return (
    <div className={`upload-progress ${status}`}>
      <div className="file-preview">
        {preview && (
          <img 
            src={preview} 
            alt={name}
            className="preview-image"
          />
        )}
      </div>
      
      <div className="file-info">
        <div className="file-header">
          <span className="status-icon">{getStatusIcon()}</span>
          <span className="file-name">{name}</span>
          <span className="file-size">{formatFileSize(size)}</span>
        </div>
        
        <div className="file-status">
          <span className="status-text">{getStatusText()}</span>
        </div>
        
        {status === 'uploading' && (
          <div className="progress-bar">
            <div 
              className="progress-fill"
              style={{ width: `${progress}%` }}
            />
          </div>
        )}
      </div>
      
      <div className="file-actions">
        {(status === 'pending' || status === 'error') && (
          <button 
            onClick={onRemove}
            disabled={disabled}
            className="remove-button"
            title="Remove file"
          >
            🗑️
          </button>
        )}
      </div>
    </div>
  );
};

export default UploadProgress;
